// @ts-ignore
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";
import ImageGallery from "react-image-gallery";
import _ from "lodash";
import styled from "styled-components";

import shareImage from "../../assets/images/share.png";

import { DormitoryTab } from "./dormitories-page";

import copy from "copy-to-clipboard";

import Tags from "components/tools/tags";
import { Breadcrumb, Button, Container, Frame, RowWrapper } from "components/ui-kit/styled-templates";

import ArticlesAPI from "api/articles-api";

import ModalsService from "services/modals-service";

import { useStorageListener } from "hooks/useStorage";

import { ERoles } from "types/enums";
import toast from "react-hot-toast";

const NewsArticlePage = () => {
    const { t } = useTranslation();

    const { newsId: articleId } = useParams();
    const navigate = useNavigate();

    const article = useStorageListener(`news.${articleId}`, {});
    const role: ERoles = useStorageListener(`user.userRole`, ERoles.Guest);

    const handlers = {
        deleteArticle: () => {
            ModalsService.showModality({
                title: `Удаление новости`,
                description: `Вы уверены, что хотите удалить эту новость?`,
                cancelButton: {
                    children: `Отмена`
                },
                confirmButton: {
                    children: `Удалить`,
                    onClick: async () => {
                        await ArticlesAPI.deleteArticle(articleId);
                        navigate(`/news`);
                    }
                }
            });
        }
    };

    // @ts-ignore
    useEffect(ArticlesAPI.getAllArticles, []);

    let xPhotos = _.get(article, "photos", []);
    // or cover
    if (_.get(article, "cover") && xPhotos.length === 0) {
        xPhotos = [_.get(article, "cover")];
    }


    useEffect(() => {
        // scroll to top after render and after article loaded
        try{
            setTimeout(() => {
                console.log('scroll to top!!!');
                window.scrollTo({
                    top: 0,
                    behavior: 'auto'
                });
                const element = document.getElementById("header_logo");
                if (element) {
                    element.scrollIntoView({
                        behavior: "auto", // Optional for smooth scrolling
                        block: "start",     // Aligns the element at the top
                    });
                }
            }, 100);
        }catch(exc){

        }
    }, [xPhotos]);

    if (_.isEmpty(article)) {
        return <NotFoundPage />;
    }




    return (
        <>
            <Frame extra="width: 100%; background: white;">
                <Container>
                    <Breadcrumb.Wrapper>
                        <Breadcrumb.Item to="/">{t("350usrkikdn")}</Breadcrumb.Item>
                        <Breadcrumb.Item to="/news">{t("pbj0sy6tgv7")}</Breadcrumb.Item>
                    </Breadcrumb.Wrapper>
                </Container>
            </Frame>
            <Container extra="margin: 56px 0;">
                <Article.Wrapper>

                    <h2 id={`article_title`} >{_.get(article, "title", "...")}</h2>

                    {/*{_.get(article, "cover") && <Article.Cover src={_.get(article, "cover")} />}*/}
                    {xPhotos.length == 1 && <Article.Cover src={xPhotos[0]} />}

                    {xPhotos.length > 1 && (
                        <>
                            <div style={{background: 'rgb(170, 170, 170, 0.1)', height: '460px', maxHeight: '460px', width: '100%', borderRadius: '12px'}}  >
                                <ImageGallery
                                    showPlayButton={false}
                                    items={xPhotos.map(x => ({original: x, thumbnail: x, originalHeight: 360, thumbnailHeight: 60}))} />
                            </div>
                            {/*<Gallery photos={data?.photos} extra="margin-top: 15px;" />*/}
                        </>
                    )}


                    {role === ERoles.Admin && (
                        <RowWrapper extra="justify-content: flex-end; gap: 15px;">
                            <Link to={`/news/${articleId}/edit`}>
                                <Button>{t("h3g06n672wo")}</Button>
                            </Link>
                            <Button background="red" onClick={handlers.deleteArticle}>
                                {t("gsw3bzlxqbj")}
                            </Button>
                        </RowWrapper>
                    )}

                    {/*<h2>{_.get(article, "title", "...")}</h2>*/}

                    <Tags tags={_.get(article, "tags", [])} />
                    <Article.Content className={'news_article'}
                        dangerouslySetInnerHTML={{ __html: _.get(article, "content", t("5c7segpnz0g")) }} />


                    <DatePlaceholder>
                        <img src={shareImage} style={{height: '32px', opacity: 0.5, marginRight: '10px', cursor: 'pointer'}}
                            onClick={() => {
                                copy(window.location.href);
                                toast.success('Ссылка скопирована в буфер обмена');
                            }}
                        />
                        {(article?.customDate == undefined || article?.customDate == "") ? null :
                            <span>
                                {article?.customDate}
                            </span>
                        }
                    </DatePlaceholder>


                </Article.Wrapper>
            </Container>
        </>
    );
};

const NotFoundPage = () => {
    const { t } = useTranslation();

    return (
        <Frame extra="min-height: 100vh;">
            <h3>{t("5ma3rri09gx")}</h3>
            <Link to="/news">
                <DormitoryTab.Link color="blue" direction="left">
                    {t("hh7e850q0g")}
                </DormitoryTab.Link>
            </Link>
        </Frame>
    );
};

const DatePlaceholder = styled.div`
  font-size: 14px;
  font-style: italic;
  text-align: right;
  opacity: 0.6;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const Article = {
    Wrapper: styled(Frame)`
      
      width: 100%;
      padding: 43px 32px;
      box-sizing: border-box;
      background: white;
      gap: 26px;
      align-items: flex-start;
      border-radius: 12px;
      
      @media (max-width: 991px) {
        padding: 10px !important;
      }
      
    `,

    Cover: styled(Frame)<{ src: string }>`
      width: 100%;
      height: 365px;
      background: url("${({ src }) => src}") no-repeat center center / cover;
    `,
    Content: styled.div`
      text-align: justify;

      a {
        color: ${({ theme }) => theme.blue};
      }
    `
};

export default NewsArticlePage;
